<div class="email-container" #emailContainer [style.max-height]="height">
  <ng-container *ngFor="let email of filteredEmails">
    <span #emailEl class="email me-3">{{ email }}</span>
  </ng-container>
  <button *ngIf="isCollapsed && count > 0" class="btn btn--link btn--link-blue m-0" (click)="onExpand()">+{{ count }} more</button>
</div>
